import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { isSessionExpiredError, isSessionLossHttpError, SessionExpiredError } from '../../auth/session-expired.util';
import { isLisaApiRequest } from './interceptor.utils';

function isAuthRoute(url: string): boolean {
  return (
    url.includes('/lisa-auth/login') ||
    url.includes('/lisa-auth/session') ||
    url.includes('/lisa-auth/logout') ||
    url.includes('/lisa-auth/reset-password/validate') ||
    url.includes('/auth/forgot-password') ||
    url.includes('/auth/reset-password')
  );
}

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const hadSession = authService.isAuthenticated();

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || !isLisaApiRequest(req.url) || isAuthRoute(req.url)) {
        return throwError(() => error);
      }

      if (authService.isSessionExpiryInProgress() || isSessionExpiredError(error)) {
        return throwError(() => new SessionExpiredError());
      }

      if (isSessionLossHttpError(error, hadSession)) {
        authService.handleSessionExpired(router.url);
        return throwError(() => new SessionExpiredError());
      }

      return throwError(() => error);
    }),
  );
};
